import React, { Component } from 'react';
import SingleCartSummery from '../components/SingleCartSummery';
import DwnldIcon from '../assets/img/download-icon.png';
import AmarlabLogo from '../assets/img/logo.png';
import DownloadWhite from '../assets/img/download-white.png';
import PdfIcon from '../assets/img/pdf.png';
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import LoadingGif from '../components/LoadingGif';
import { AuthContext } from '../context/AuthContext';
import InvoicePdf from '../components/invoice/InvoicePdf';
import { PDFDownloadLink } from '@react-pdf/renderer';
import ReportSummaryModal from '../components/reportSummary/ReportSummaryModal';
import { getAuthHeader } from '../utils/authHeader';

// A test is discountable unless its DiagnosticTest.is_discountable flag is explicitly false.
// Checks both JSON shapes the API returns a test under (single test vs package-style item).
const isOrderItemDiscountable = (item) => {
  const poi = (item && item.purchasable_order_item) || {};
  const single = poi.testitem_purchasable_oi;
  const dt1 = single && typeof single === 'object' ? single.diagnostic_test : null;
  if (dt1 && typeof dt1.is_discountable === 'boolean') {
    return dt1.is_discountable;
  }
  const orderArr = poi.testitem_purchasable_order;
  const first = Array.isArray(orderArr) && orderArr.length ? orderArr[0] : null;
  const dt2 = first && first.diagnostic_test;
  if (dt2 && typeof dt2.is_discountable === 'boolean') {
    return dt2.is_discountable;
  }
  return true;
};

// Sum of sell_price for only the discountable items in the list (e.g. excludes CBC).
const getDiscountableTestsPrice = (items = []) => {
  const price = items.reduce((total, item) => {
    if (!item || !item.purchasable_order_item) return total;
    if (isOrderItemDiscountable(item) === false) return total;
    return total + parseInt(item.purchasable_order_item.sell_price);
  }, 0);
  return parseInt(price) || 0;
};

class OrderDetails extends Component {
  state = {
    order: null,
    userLocalId: null,
    discountPrice: null,
    materialPerson: null,
    discount: null,
    feesZero: false,
    fees: { meterial_fee: 50, collection_fee: 200 },
    loading: true,
    reports: null,
    patientOrders: [],
    discountPercentage: null,
    // AI report summary
    summaryModalOpen: false,
    summaryModalPatient: null,
    summarizeEnabled: false,
  };

  getFees = () => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/diagnostic/fees/`)
      .then((resp) => {
        // this.setState({
        //   fees: resp.data.results[0],
        // });
        // console.log('fees = ', resp.data.results[0]);
      })
      .catch((error) => { });
  };

  handleMeterialPerson = (array) => {
    const patients = array
      .map((patient) => {
        return patient.patient.id;
      })
      .filter((x, i, a) => a.indexOf(x) === i);
    // console.log(patients.length);
    this.setState({ materialPerson: patients.length });
  };

  serviceFeesRemove = (array) => {
    const testItems = array
      .filter((item) => {
        return item.order_type === 'diagnostic';
      })
      .map((item) => {
        return item.purchasable_order_item.testitem_purchasable_oi
          .diagnostic_test.name;
      });

    const checkOne = testItems.includes('Covid RT PCR');
    const checkTwo = testItems.includes('Covid Antigen');

    // console.log(checkTwo);
    if (checkOne || checkTwo) {
      this.setState({ fees: { meterial_fee: 0, collection_fee: 0 } });
    }
  };

  petientReports = (reports) => {
    const patientDetails = reports.map((item) => item.patient);
    const ids = patientDetails.map((o) => o.id);
    const filteredPatient = patientDetails.filter(
      ({ id }, index) => !ids.includes(id, index + 1)
    );

    let patientOrders = [];
    filteredPatient.forEach((patient) => {
      const result = reports.filter((o1) => {
        return o1.patient.id === patient.id;
      });
      const newArray = {
        patient: patient,
        reports: result,
      };
      patientOrders.push(newArray);
    });
    // console.log(patientOrders);
    this.setState({ reports: patientOrders });
  };

  handlePatientOrders = (order) => {
    const itemArray = order.orderitem;
    const patientDetails = itemArray.map((item) => item.patient);
    const ids = patientDetails.map((o) => o.id);
    const filteredPatient = patientDetails.filter(
      ({ id }, index) => !ids.includes(id, index + 1)
    );
    // console.log(itemArray);
    // console.log(filteredPatient);
    let patientOrders = [];

    filteredPatient.forEach((patient) => {
      const result = itemArray.filter((o1) => {
        return o1.patient.id === patient.id;
      });
      const newArray = {
        patient: patient,
        testItem: result,
      };
      patientOrders.push(newArray);
      // console.log(newArray);
    });
    patientOrders.sort((p) => (p.patient.is_account ? -1 : 1));
    // setCtCPatient(patientOrders);
    this.setState({ patientOrders: patientOrders });
    // console.log(patientOrders);
  };

  fetchSingleOrder = (id, passedUserId) => {
    const localUserId =
      passedUserId !== undefined && passedUserId !== null
        ? passedUserId
        : this.state.userLocalId !== null
        ? this.state.userLocalId
        : localStorage.getItem('user_id')
        ? JSON.parse(localStorage.getItem('user_id'))
        : null;

    const auth = getAuthHeader();
    const headers = auth || {};

    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/order/order-tree/${id}/?user=${localUserId}`,
        { headers }
      )
      .then((resp) => {
        if (!resp.data) {
          this.setState({ loading: false });
          return;
        }

        this.handlePatientOrders(resp.data);

        if (resp.data.orderdiscount && resp.data.orderdiscount.discount_price) {
          const discountableBase = getDiscountableTestsPrice(resp.data.orderitem);
          const discountBase =
            discountableBase > 0 ? discountableBase : parseInt(resp.data.total_price);
          const discountPercentage =
            discountBase > 0
              ? (parseInt(resp.data.orderdiscount.discount_price) / discountBase) * 100
              : 0;
          this.setState({ discountPercentage: discountPercentage });
        }

        this.petientReports(resp.data.orderreport || []);
        this.setState({ loading: false });

        const discount = (resp.data.orderitem || []).reduce(
          (total, item) => total + (parseInt(item.discount_price) || 0),
          0
        );

        if (!resp.data.orderdiscount && discount > 0) {
          this.setState({ discount: discount });
        }

        this.serviceFeesRemove(resp.data.orderitem || []);

        const orderUserId = resp.data.user
          ? typeof resp.data.user === 'object'
            ? resp.data.user.id || resp.data.user.pk
            : resp.data.user
          : null;

        if (localUserId && orderUserId && String(localUserId) !== String(orderUserId)) {
          this.props.history.push('/order-history');
          toast.error("You don't have permission to show the order.", {
            autoClose: 3000,
          });
        } else {
          this.setState({ order: resp.data, userLocalId: localUserId });
          if (
            resp.data &&
            resp.data.orderdiscount &&
            resp.data.orderdiscount.discount_price
          ) {
            this.setState({
              discountPrice: parseInt(resp.data.orderdiscount.discount_price),
            });
          }
          this.handleMeterialPerson(resp.data.orderitem || []);
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        if (error.response && (error.response.status === 404 || error.response.status === 403)) {
          toast.error("You don't have permission to view this order or it was not found.", {
            autoClose: 3000,
          });
          this.props.history.push('/order-history');
        }
      });
  };

  goToPayment = () => {
    if (!this.state.order) return;
    const orderDetail = this.state.order.orderdetail || {};
    const addressData = orderDetail.address || {};

    let user_name, address, user_email;

    if (
      this.state.order.user &&
      this.state.order.user.patient &&
      this.state.order.user.patient.full_name
    ) {
      user_name = this.state.order.user.patient.full_name;
    } else {
      user_name = this.state.order.user ? this.state.order.user.username : '';
    }

    if (addressData.email) {
      user_email = addressData.email;
    } else {
      user_email = 'info@amarlab.com';
    }

    address = [addressData.address, addressData.thana, addressData.district]
      .filter(Boolean)
      .join(', ');

    const paymentData = {
      total_price:
        parseInt(this.state.order.total_price || 0) +
        parseInt(this.state.order.material_fee || 0) +
        parseInt(this.state.order.collection_fee || 0) -
        (this.state.discountPrice || 0),
      category: 'diagnostic-test',
      order_id: '#' + this.state.order.order_id,
      order_quantity: this.state.order.orderitem ? this.state.order.orderitem.length : 0,
      contact_name: user_name,
      contact_email: user_email,
      contact_address: address,
      contact_mobile: addressData.mobile || '',
      order_pk: this.state.order.id,
    };

    const mainPrice = this.state.order.total_price;
    const materialFee = this.state.order.material_fee;
    const collectionFee = this.state.order.collection_fee;
    const couponPrice =
      this.state.order.orderdiscount &&
      this.state.order.orderdiscount.discount_price
        ? parseInt(this.state.order.orderdiscount.discount_price)
        : 0;

    localStorage.setItem('main_price', JSON.stringify(mainPrice));
    localStorage.setItem('material_fee', JSON.stringify(materialFee));
    localStorage.setItem('collection_fee', JSON.stringify(collectionFee));
    localStorage.setItem('coupon_fee', JSON.stringify(couponPrice));

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/order/init-payment`, paymentData)
      .then((resp) => {
        if (resp.data.response && resp.data.response.status === 'SUCCESS') {
          window.location = resp.data.response.GatewayPageURL;
        } else {
          toast.error(
            'Something went wrong, you are not able to payment now, please contact our customar care for cash on delivery.',
            {
              autoClose: 3000,
            }
          );
        }
      })
      .catch((error) => {
        // console.log(error.response);
      });
  };

  componentDidMount() {
    this.context.setPageTitle('Order Details');
    window.scrollTo(0, 0);
    const token = localStorage.getItem('token');
    const rawUserId = localStorage.getItem('user_id');

    if (!token) {
      this.props.history.push(
        `/login?redirect=${this.props.location.pathname}`
      );
      return;
    }
    if (!rawUserId) {
      this.props.history.push(
        `/login?redirect=${this.props.location.pathname}`
      );
      return;
    }

    let parsedUserId = null;
    try {
      parsedUserId = JSON.parse(rawUserId);
    } catch (e) {
      parsedUserId = rawUserId;
    }

    this.setState({ userLocalId: parsedUserId });
    this.fetchSingleOrder(this.props.match.params.id, parsedUserId);
    this.getFees();
    this.fetchSummarizeEnabled();

    this.orderLiveInterval = setInterval(() => {
      if (typeof document !== 'undefined' && document.hidden) return;
      const currentStatus =
        this.state.order &&
        this.state.order.orderdetail &&
        this.state.order.orderdetail.order_status;
      if (currentStatus === 'completed' || currentStatus === 'cancelled') {
        if (this.orderLiveInterval) clearInterval(this.orderLiveInterval);
        return;
      }
      if (this.props.match && this.props.match.params && this.props.match.params.id) {
        this.fetchSingleOrder(this.props.match.params.id, this.state.userLocalId);
      }
    }, 15000);
  }

  componentWillUnmount() {
    if (this.orderLiveInterval) {
      clearInterval(this.orderLiveInterval);
    }
  }

  // Whether AI summary is switched on for this user. `enabled` folds together
  // AI_SUMMARY_ENABLED, the AI service being configured, and the per-user block
  // list — so a blocked user simply never sees the button. Any failure leaves it
  // off rather than showing a button that cannot work.
  fetchSummarizeEnabled = () => {
    const auth = getAuthHeader();
    if (!auth) return;
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/order/report-summary-quota/`, {
        headers: auth,
      })
      .then((resp) => {
        this.setState({ summarizeEnabled: !!(resp.data && resp.data.enabled) });
      })
      .catch(() => {
        this.setState({ summarizeEnabled: false });
      });
  };

  mainBill = (obj) => {
    const total = parseInt(obj.total_price);
    const pickupChange = obj.collection_fee;

    return (
      total -
      (pickupChange + this.state.materialPerson * obj.orderitem[0].meterial_fee)
    );
  };

  render() {
    const {
      order,
      discountPrice,
      materialPerson,
      loading,
      reports,
      patientOrders,
      discountPercentage,
    } = this.state;

    const orderDetail = (order && order.orderdetail) || {};
    const addressData = orderDetail.address || {};
    const orderStatus = orderDetail.order_status || 'pending';
    const paymentStatus = orderDetail.payment_status || 'unpaid';
    const deliveryCopy = orderDetail.delivery_copy_status
      ? orderDetail.delivery_copy_status.replace(/_/g, ' ')
      : 'Soft';

    return (
      <section className='order-place-details details'>
        <div className='container'>
          {loading ? (
            <LoadingGif />
          ) : (
            <>
              {order && (
                <div className='row'>
                  <div className='col-lg-8 left'>
                    <h5 className='main-heading'>
                      {paymentStatus === 'unpaid'
                        ? 'Order Placed (Cash on Delivery)'
                        : 'Order Details'}
                    </h5>
                    <p className='id'>#{order.order_id}</p>
                    <p className='date report-first mobile'>
                      <div className='report_del'>
                        <span>Order Status: </span>{' '}
                        <span
                          className={`text-capitalize ${orderStatus}`}
                        >
                          {orderStatus === 'cancel'
                            ? 'Cancelled'
                            : orderStatus.replace(/_/g, ' ')}
                        </span>
                      </div>
                      {reports && reports.length !== 0 && (
                        <button className='btn btn-primary' disabled>
                          <img src={DownloadWhite} alt='' /> Download Reports
                        </button>
                      )}
                    </p>
                    <p className='mobile font-20 sample_coll'>
                      <span className='font-semibold'>
                        Sample Collection Date:
                      </span>{' '}
                      {moment(order.date).format('DD MMM YYYY')}
                    </p>
                    <div className='location'>
                      <p className='left font-semibold'>
                        Sample Collection Location:
                      </p>
                      <div className='right'>
                        <p className='bottom'>
                          {[addressData.address, addressData.thana, addressData.district]
                            .filter(Boolean)
                            .join(', ')}
                        </p>
                      </div>
                    </div>
                    <p className='date report-first mobile'>
                      <div className='report_del'>
                        <span>Report Delivery Status: </span>{' '}
                        <span
                          className={`text-capitalize`}
                        >
                          {deliveryCopy} Copy
                        </span>
                      </div>
                    </p>
                    {orderDetail.estimate_date && (
                      <p className='date mb-4'>
                        <span className='font-semibold'>
                          Estimated Report Delivery:{' '}
                        </span>{' '}
                        {moment(orderDetail.estimate_date).format(
                          'DD MMM YYYY'
                        )}
                      </p>
                    )}
                    {order.orderdelivery && order.orderdelivery.length !== 0 && (
                      <div className='location'>
                        <p className='left font-semibold'>
                          Report Delivery Status:
                        </p>
                        <div
                          className='right report_delivery'
                          style={{
                            display: 'flex',
                            flexDirection: 'column-reverse',
                          }}
                        >
                          {order.orderdelivery.map((status, i) => (
                            <p
                              className='top font-20 mb-0 text-capitalize'
                              key={i}
                            >
                              {status.name.replace(/_/g, ' ')}{' '}
                              <p className='date'>
                                &mdash;{' '}
                                {moment(status.created_at).format(
                                  'DD MMM YYYY; hh:mm A'
                                )}
                              </p>
                            </p>
                          ))}
                        </div>
                      </div>
                    )}
                    {addressData.mobile && (
                      <p className='mobile font-20'>
                        <span className='font-semibold'>Contact Number:</span> +88{' '}
                        {addressData.mobile}
                      </p>
                    )}
                    {addressData.email && (
                      <p className='email font-20'>
                        <span className='font-semibold'>Email:</span>{' '}
                        {addressData.email}
                      </p>
                    )}
                    <div className='cart-summery'>
                      <h5 className='mb-0 font-semibold'>Order Summary</h5>
                    </div>
                    <div className='list summery_cart'>
                      <div className='order_summery'>
                        <div className='lab-logo'>
                          <span>Ordered From:</span>
                          {order.orderitem && order.orderitem.length !== 0 &&
                          order.orderitem[0].purchasable_order_item &&
                          order.orderitem[0].purchasable_order_item.testitem_purchasable_oi &&
                          order.orderitem[0].purchasable_order_item.testitem_purchasable_oi.branch &&
                          order.orderitem[0].purchasable_order_item.testitem_purchasable_oi.branch.lab ? (
                            <img
                              src={
                                order.orderitem[0].purchasable_order_item
                                  .testitem_purchasable_oi.branch.lab.logo
                              }
                              alt='lab logo'
                            />
                          ) : (
                            <img src={AmarlabLogo} alt='lab logo' />
                          )}
                        </div>
                        <div className='lists'>
                          {order.orderitem && order.orderitem.length !== 0 && (
                            <>
                              {patientOrders &&
                                patientOrders.map((patinet, i) => (
                                  <SingleCartSummery key={i} item={patinet} />
                                ))}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    {paymentStatus === 'unpaid' &&
                      (orderStatus !== 'cancel' &&
                        orderStatus !== 'completed') && (
                        <>
                          <div className='bottom bg-primary'>
                            <h5>
                              Order Placed At Cash On Delivery But You Can Still
                              Pay Now For This Order
                            </h5>
                            <button
                              onClick={(e) => {
                                this.goToPayment();
                                this.context.postActivity(
                                  'button',
                                  `Pay Now (${order.order_id})`,
                                  window.location.href
                                );
                              }}
                              className='btn btn-warning'
                            >
                              Pay Now
                            </button>
                          </div>
                          <p className='terms'>
                            * By completing your purchase you agree to this{' '}
                            <Link
                              to='/terms-of-service'
                              className='font-semibold'
                            >
                              Terms of Service.
                            </Link>
                          </p>
                        </>
                      )}
                    <div className='available-reports'>
                      {/* Cancelled orders expose no reports and no AI at all. */}
                      {orderStatus !== 'cancel' &&
                        reports && reports.length !== 0 && (
                        <div className='cart-summery'>
                          <h5 className='mb-0 font-20 font-semibold'>
                            Available Reports
                          </h5>
                          <div className='d-flex align-items-center'>
                            <button className='btn btn-primary' disabled>
                              <img src={DownloadWhite} alt='' /> Download All
                            </button>
                          </div>
                        </div>
                      )}
                      <div className='items'>
                        {orderStatus !== 'cancel' &&
                          reports &&
                          reports.map((report, i) => (
                            <div className='single' key={i}>
                              <div className='card'>
                                <div
                                  className='name d-flex align-items-center justify-content-between'
                                >
                                  <div>
                                    <span className='font-semibold'>
                                      Patient:
                                    </span>{' '}
                                    {report.patient ? report.patient.full_name : ''},{' '}
                                    <span className='age'>
                                      {report.patient && report.patient.dob
                                        ? moment().diff(
                                            `${report.patient.dob}`,
                                            'years'
                                          ) + ' Years'
                                        : ''}
                                    </span>
                                  </div>
                                  {this.state.summarizeEnabled &&
                                    orderStatus === 'completed' && (
                                    <button
                                      type='button'
                                      className='btn'
                                      style={{
                                        backgroundColor: '#fbe582',
                                        color: '#1C1C1C',
                                        fontWeight: 600,
                                        flex: '0 0 auto',
                                        marginLeft: 10,
                                      }}
                                      onClick={() => {
                                        this.context.postActivity(
                                          'button',
                                          `Summarize Report (${report.patient ? report.patient.id : ''})`,
                                          window.location.href
                                        );
                                        this.setState({
                                          summaryModalOpen: true,
                                          summaryModalPatient: report,
                                        });
                                      }}
                                    >
                                      <svg
                                        width='15'
                                        height='15'
                                        viewBox='0 0 24 24'
                                        fill='#1C1C1C'
                                        style={{ marginRight: 6, verticalAlign: '-2px' }}
                                        aria-hidden='true'
                                      >
                                        <path d='M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z' />
                                      </svg>
                                      Summarize
                                    </button>
                                  )}
                                </div>
                                {report.reports && report.reports.map((file, i) => (
                                  <div className='pdf' key={i}>
                                    <div className='left'>
                                      <img src={PdfIcon} alt='' />
                                      <div className='name-date'>
                                        <p className='name'>
                                          {file.name
                                            ? file.name
                                            : 'Report ' + (i + 1)}
                                        </p>
                                        <p className='date'>
                                          Uploaded on:{' '}
                                          {moment(file.created_at).format(
                                            'DD MMM YYYY; hh:mm A'
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                    <div className='right'>
                                      <a
                                        href={file.report}
                                        className='btn btn-primary'
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        onClick={() =>
                                          this.context.postActivity(
                                            'button',
                                            `Download Report (${file.id})`,
                                            window.location.href
                                          )
                                        }
                                      >
                                        <img src={DownloadWhite} alt='' />{' '}
                                        Download
                                      </a>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-4 right'>
                    <div className='card'>
                      <h5 className='title'>Payment Summary</h5>
                      <div className='cost'>
                        <div className='price'>
                          <p>Total Price</p>
                          <p className='bold-text'>
                            ৳ {parseInt(order.total_price || 0)}
                          </p>
                        </div>
                        <div className='price'>
                          <p>Pick up charges</p>
                          <p className='bold-text'>
                            ৳ {parseInt(order.collection_fee || 0)}
                          </p>
                        </div>
                        <div className='price'>
                          <p>
                            Material fee {parseInt(order.material_fee || 0)} *{' '}
                            {materialPerson ? materialPerson : '0'}
                          </p>
                          <p className='bold-text'>
                            ৳ {parseInt(order.material_fee || 0)}
                          </p>
                        </div>
                        {discountPrice && (
                          <div className='price'>
                            <p>Discount</p>
                            <p className='bold-text'>
                              - ৳ {discountPrice || '00'}
                            </p>
                          </div>
                        )}
                        <div className='break'></div>
                        <div className='price'>
                          <p className='bold-text'>Total:</p>
                          <p className='bold-text'>
                            ৳{' '}
                            {discountPrice
                              ? parseInt(order.total_price || 0) +
                              parseInt(order.material_fee || 0) +
                              parseInt(order.collection_fee || 0) -
                              discountPrice
                              : parseInt(order.total_price || 0) +
                              parseInt(order.material_fee || 0) +
                              parseInt(order.collection_fee || 0)}
                          </p>
                        </div>
                      </div>
                      <div className='bottom'>
                        {paymentStatus === 'paid' ? (
                          <>
                            <PDFDownloadLink
                              document={
                                <InvoicePdf
                                  order={order}
                                  materialPerson={materialPerson}
                                  discountPrice={discountPrice}
                                  patientOrders={patientOrders}
                                  discountPercentage={discountPercentage}
                                />
                              }
                              fileName={`Order ${order.order_id} Invoice`}
                            >
                              {({ blob, url, loading, error }) =>
                                loading ? (
                                  'Loading document...'
                                ) : (
                                  <span
                                    onClick={() =>
                                      this.context.postActivity(
                                        'button',
                                        'Download Invoice',
                                        window.location.href
                                      )
                                    }
                                  >
                                    <img src={DwnldIcon} alt='' />
                                    Download Invoice
                                  </span>
                                )
                              }
                            </PDFDownloadLink>

                            <p className='mb-0 font-semibold text-uppercase'>
                              {paymentStatus}
                            </p>
                          </>
                        ) : ((orderStatus !== 'cancel' &&
                          orderStatus !== 'completed') &&
                          <button
                            onClick={(e) => {
                              this.goToPayment();
                              this.context.postActivity(
                                'button',
                                `Pay Now (${order.order_id})`,
                                window.location.href
                              );
                            }}
                            className='btn btn-primary btn-block primary'
                          >
                            Pay Now
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        <ReportSummaryModal
          show={this.state.summaryModalOpen}
          order={order}
          patient={this.state.summaryModalPatient}
          onClose={() =>
            this.setState({ summaryModalOpen: false, summaryModalPatient: null })
          }
        />
      </section>
    );
  }
}

export default OrderDetails;
OrderDetails.contextType = AuthContext;
